<h1 matDialogTitle>{{ 'Upload Config' | translate }}</h1>
<form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
  <div [innerHtml]="helptext.upload_config_form.message | translate"></div>

  <ix-file-input
    formControlName="config"
    [label]="'Select Configuration File' | translate"
  ></ix-file-input>

  <ix-form-actions>
    <button mat-button type="button" ixTest="cancel" [matDialogClose]="false">
      {{ 'Cancel' | translate }}
    </button>
    <button
      *ixRequiresRoles="requiredRoles"
      mat-button
      type="submit"
      color="primary"
      ixTest="upload"
      [disabled]="form.invalid"
    >
      {{ 'Upload' | translate }}
    </button>
  </ix-form-actions>
</form>
